personalFinance = {
	sumInput: function(selector) {
		var
			$input = $(selector);

		if (!$input.length) return;

		$input.on('change', function() {
			var
				$input = $(this),
				val = Number($input.val()),
				min = Number($input.attr('min')),
				max = Number($input.attr('max'));

			var round = (x) => Math.round(x / 1000) * 1000;

			min = round(min);
			max = round(max);
			val = round(val);

			if (val < min) val = min;
			if (val > max) val = max;

			$input.val(val);
		})
	}
}